import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Emoji } from './emoji';

@Injectable()

export class EmojiPickerService {

    private _emojiService = new BehaviorSubject<any>({});
    emojiSource$ = this._emojiService.asObservable();

    showEmojiPicker(show = true) {
        // this._emojiPickerService.next({ show: show });
    }

    selectEmoji(emoji: Emoji) {
        this._emojiService.next(<Emoji>emoji);
    }
}
